import { Box, Modal } from "@mui/material";

interface Props {
  open: boolean;
}

const NetworkError = ({ open }: Props) => {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="expiredModalContent" style={{backgroundColor:"#ff0000", color: "#fff"}}>
        <div className="header">Network Error</div>
        <p> There was a problem communicating with the application server. Please
          notify the administrator.</p>
      </Box>
    </Modal>
  );
};
export default NetworkError;
